import { NewDelete_VehicleContext } from 'components/StraightThroughVehicleComp/ReplaceVehicleContext/NewDelete_VehicleContext'
import { ReplaceVehicleContext } from 'components/StraightThroughVehicleComp/ReplaceVehicleContext/ReplaceVehicleContext'
import { RemoveVehicleValidationForm } from 'components/StraightThroughVehicleComp/ValidationForms/RemoveVehicleValidationForm'
import React, { useContext, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { submitEndorsement } from 'services/Api'
import { storageData } from 'services/Services'
import { ValidationForm } from "components/StraightThroughVehicleComp/ValidationForms/ValidationsForm";

const ReplaceVehicleBtnNav = () => {
    const navigate = useNavigate()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const replaceVehicleContext = useContext(ReplaceVehicleContext)
    const newDeleteVehicleContext = useContext(NewDelete_VehicleContext)
    var replaceVehicleClass = replaceVehicleContext?.replaceVehicleClass
    var deletedVehicle = newDeleteVehicleContext?.deleteVehicle
    var newVehicle = newDeleteVehicleContext?.newVehicle
    var newVehicles = replaceVehicleContext?.replaceVehicleClass?.vehicles.vehiclesOnPolicy.newVehicles
    var deletedFormFilled = deletedVehicle?.requestedRemovalEffDate != "" && deletedVehicle?.vehicleRemovalReason != ""
    var screen = window.location.pathname.split("/").pop()
    var newVehComponent = newVehicle?.componentTracker
    const formComponents = ["VehicleInfo", "VehiclePurchased", "VehicleOwned", "VehicleLeased", "VehicleFinanced"]

    // ensure that the Next button only appears once the added vehicle has a filled out Date Purchased option
    var addedFormFilled = (formComponents.includes(newVehicles[0]?.componentTracker) || newVehicles[0]?.componentTracker == "VehicleDriverAssignment")
    && newVehicles[0]?.componentTracker !== 'VehicleInfo' 
    && newVehicles[0]?.componentTracker !== 'VehiclePurchased'

    const navigateBack = () => {
        // First page
        if (screen == "replace-vehicle") {
            // Navigate to the VIN input component
            if (formComponents?.includes(newVehComponent)) {
                var vehicleClassCopy = replaceVehicleContext.replaceVehicleClass
                vehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles.length = 0
                replaceVehicleContext.setReplaceVehicleClass({ ...vehicleClassCopy });
                newDeleteVehicleContext.setNewVehicle({ ...newDeleteVehicleContext.initialVehicle })
                storageData.setItem("ReplaceVehicleClass", JSON.stringify(vehicleClassCopy))
            }
            // Return to home page
            else if (newVehComponent != "VehicleDriverAssignment") {
                replaceVehicleContext?.clear()
                window.location.href = "/home"
            }
            // Return to form
            else if (newVehComponent == "VehicleDriverAssignment") {
                updateComponentTracker("Vehicle" + newDeleteVehicleContext.newVehicle.vehicleOwnedLeasedFinanced)
            }
        }
        // Confirm page
        else if (screen == "replace-vehicle-confirm") {
            navigate("/endorsement/replace-vehicle")
        }
    }

    // Updates the use-state for immediate re-render
    const updateComponentTracker = (componentName) => {
        deletedVehicle["componentTracker"] = componentName
        newVehicle["componentTracker"] = componentName

        var replaceVehicleClassCopy = replaceVehicleClass
        replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0] = deletedVehicle
        replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles[0] = newVehicle
        replaceVehicleClassCopy.screenName = (newVehComponent == "VehicleDriverAssignment") ? "Vehicle" : "Driver Assignment"
        replaceVehicleClassCopy.driverAssignment.vehicles = assignNewVehicleToDriverAssignment(replaceVehicleClassCopy)
        replaceVehicleClassCopy.driverAssignment.vehicles = removeVehicleForDriverAssignment(replaceVehicleClassCopy)
        replaceVehicleContext.setReplaceVehicleClass({ ...replaceVehicleClassCopy });
        storageData.setItem("ReplaceVehicleClass", JSON.stringify(replaceVehicleClassCopy))
    }

    // New Vehicle added to vehicles list in Driver Assignment of Add Vehicle Class
    const assignNewVehicleToDriverAssignment = (replaceVehicleClassCopy) => {
        // Driver Assignment vehicles adds the new vehicle if it has not already
        var combinedVehicles = [replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles[0], ...replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.storedVehicles]
        return combinedVehicles
    }

    // Removes the vehicle from the driver assignment list
    const removeVehicleForDriverAssignment = (replaceVehicleClassCopy) => {
        var driverAssignmentVehicles = replaceVehicleClassCopy.driverAssignment.vehicles
        driverAssignmentVehicles = driverAssignmentVehicles.filter(veh =>
            veh?.VIN != replaceVehicleClassCopy.vehicles.vehiclesOnPolicy.removedVehicles[0].VIN
        );
        return driverAssignmentVehicles
    }

    // Next button component navigation
    const nextButtonNavigate = async () => {
        if (screen == "replace-vehicle") {
            var alertMsg = ValidationForm(newVehicle, replaceVehicleContext.replaceVehicleClass.driverAssignment.vehicles, replaceVehicleContext.replaceVehicleClass.driverAssignment.drivers, replaceVehicleContext.userData.state)

            if (alertMsg) {
                replaceVehicleContext.setValidationMsgToggle(
                    alertMsg?.title || 'Oops!',
                    alertMsg?.message || 'Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.'
                );
                return;
            }
            // var alertMsg = RemoveVehicleValidationForm(removeVehicleClass, deletedVehicle, removeVehicleClass.driverAssignment.vehicles, removeVehicleClass.driverAssignment.drivers, replaceVehicleContext.userData.state)

            // if (alertMsg) {
            //     replaceVehicleContext.setValidationMsgToggle(
            //         alertMsg?.title || 'Oops!',
            //         alertMsg?.message || 'Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.'
            //     );
            //     return;
            // }    

            // Navigate to driver assignment page
            if (newVehComponent != "VehicleDriverAssignment") {
                updateComponentTracker("VehicleDriverAssignment")
            }
            // Navigate to confirm page
            else if (newVehComponent == "VehicleDriverAssignment") {
                navigate("/endorsement/replace-vehicle-confirm")
            }
        }
        else if (screen == "replace-vehicle-confirm") {
            if (!replaceVehicleContext?.replaceVehicleClass?.confirmation) {
                replaceVehicleContext.setValidationMsgToggle("Oops!", "Please certify that the answers to the questions listed in the change are true and accurate to the best of your knowledge to submit your request.")
                return;
            }
            // Send endorsement class to backend
            var req = {
                "requestType": "Replace Vehicle",
                "classRequest": storageData.getItem("ReplaceVehicleClass")
            }
            setIsSubmitting(true);
            replaceVehicleContext?.setSubmissionLoad(true); // Display spinner and hide nav buttons

            // Api call to send data
            try {
                const response = await submitEndorsement(req);
                storageData.setItem("responseData", JSON.stringify(response.data));
                redirectWithRemoves(response.data?.requestStatus)
            } catch (error) {
                console.error("Error submitting endorsement:", error);
                replaceVehicleContext?.setSubmitEndorsementResponse({ error: true, message: "An error occurred while submitting the endorsement." });
            } finally {
                setIsSubmitting(false);
                replaceVehicleContext?.setSubmissionLoad(false); // Hide spinner and display nav buttons
            }
        }
    }

    // Removes last 2 pages from history stack to allow back button to home
    const redirectWithRemoves = (status) => {
        window.history.pushState(null, null, window.location.href);
        window.history.go(-2);
        window.history.replaceState(null, null, window.location.href);

        if (status == "Failed") {
            window.location.replace('/endorsement/replace-vehicle-thank-you')
        }
        else if (status == "Blocked") {
            window.location.replace('/endorsement/replace-vehicle-block')
        }
        else {
            window.location.replace('/endorsement/replace-vehicle-summary');
        }
    }

    return (
        <>
            <div className="mt-2 mb-3">
                <div>
                    {!replaceVehicleContext?.submissionLoad &&
                        <>
                            {/* Back Button */}
                            <button type="button" className="btn btn-default editCancelBtn" onClick={() => { navigateBack() }}>
                                BACK
                            </button>
                            {/* Continue Button */}
                            {replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles?.length > 0 && deletedFormFilled && addedFormFilled && screen != "replace-vehicle-confirm" &&
                                <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={() => { nextButtonNavigate() }}>
                                    NEXT
                                </button>
                            }
                            {/* Submit Button (Only for Confirm Page) */}
                            {screen == "replace-vehicle-confirm" &&
                                <button type="submit" className="btn btn-primary-grad right pull-right editCancelBtn" onClick={() => { nextButtonNavigate() }}>
                                    SUBMIT
                                </button>
                            }
                        </>
                    }
                    {/* Spinner for retrieving vehicle info from vin */}
                    {replaceVehicleContext?.submissionLoad &&
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    }

                </div>
            </div>
        </>
    )
}

export default ReplaceVehicleBtnNav